<template>
	<div>
		<div class="community_content">
			<p class="community_hello">Hello Alan Walker,  Welcome Back</p>
			<div class="community_box community_box2">
				<p>School of</p>
				<p>Data Science &</p>
				<p>Artificial Intelligence<label></label></p>
				<div v-if="!download_show" class="download" @click="download">
					<svg preserveAspectRatio="xMidYMid meet" data-bbox="46.5 53.605 107.001 91.997" viewBox="46.500423431396484 53.6049919128418 107.000732421875 91.99668884277344" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
						<g>
							<path d="M141.796 86.941a30.774 30.774 0 0 0-.177-7.123c-1.952-13.646-12.874-24.335-26.565-25.994-10.476-1.27-20.894 3.049-27.478 11.251-.064-.012-.126-.036-.19-.047a19.332 19.332 0 0 0-14.551 3.201 19.356 19.356 0 0 0-8.32 15.934h-.11c-8.505 0-15.979 6.104-17.506 14.675-1.717 9.649 2.179 18.062 10.421 22.504l.255.137c2.832 1.536 5.028 2.729 20.843 2.729 3.766 0 8.31-.067 13.813-.215a1.722 1.722 0 0 0 1.677-1.768c-.027-.951-.893-1.743-1.767-1.678-27.693.734-30.116-.579-32.924-2.1l-.262-.142c-6.97-3.756-10.127-10.63-8.662-18.864 1.333-7.484 8.3-12.643 15.834-11.727a1.746 1.746 0 0 0 1.412-.482c.372-.367.559-.884.507-1.405a16.033 16.033 0 0 1 .155-4.436 15.932 15.932 0 0 1 6.606-10.336c3.511-2.448 7.766-3.389 11.976-2.633a15.964 15.964 0 0 1 7.574 3.596 1.725 1.725 0 0 0 2.241-2.622c-1.617-1.383-3.456-2.447-5.408-3.233 5.868-6.568 14.626-9.99 23.451-8.917 12.146 1.472 21.838 10.954 23.565 23.059.337 2.345.362 4.741.055 7.224l-.05.285a1.725 1.725 0 0 0 1.138 1.868c7.035 2.467 11.489 9.634 10.594 17.043-1.008 8.311-8.595 14.126-18 13.974-4.946-.112-17.411-.157-23.995-.165h-.002a1.725 1.725 0 0 0-.003 3.449c6.571.007 19.003.052 23.92.162.195.005.389.007.581.007 10.96 0 19.715-7.079 20.918-17.013 1.034-8.534-3.78-16.807-11.566-20.198z" fill="#45C6C9" data-color="1"></path>
							<path d="M106.018 135.241l-4.23 4.375V92.128c0-.951-.774-1.726-1.724-1.726s-1.724.774-1.724 1.726v47.488l-4.23-4.375a1.724 1.724 0 0 0-2.476 2.397l7.192 7.439c.002.003.007.004.009.006a1.713 1.713 0 0 0 2.456 0l.009-.006 7.192-7.439a1.724 1.724 0 0 0-.04-2.437 1.719 1.719 0 0 0-2.434.04z" fill="#45C6C9" data-color="1"></path>
						</g>
					</svg>
					<p>资料下载</p>
				</div>
				<ul v-if="!download_show">
					<li v-for="(item,index) in list" :key="index">
						<dl>
							<dd>{{item.title}}</dd>
							<dd>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="37.5 15.1 125 169.9" viewBox="37.5 15.099998474121094 125 169.89996337890625" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
									<g>
										<path d="M148 98.9c-7.6-6.4-17.8-10.5-30.4-12.4 12-6.4 20.2-19 20.2-33.5 0-20.9-17-37.9-37.8-37.9S62.2 32 62.2 52.9c0 14.6 8.3 27.3 20.4 33.6-12.5 2.1-22.9 6.5-30.7 13.2-9.2 7.9-14.4 18.7-14.4 29.9v40.1c0 1.7 1 6 9.8 9.4 9.9 3.9 27.2 5.9 51.2 5.9 25.3 0 43.4-2 53.8-5.9 8.9-3.3 10.2-7.4 10.2-9.5v-39.4c0-8.8-2.5-21.4-14.5-31.3zm-77.6-46c0-16.3 13.3-29.6 29.6-29.6s29.6 13.3 29.6 29.6-13.3 29.6-29.6 29.6-29.6-13.3-29.6-29.6zm83.9 115.9c-1.4 1.4-10.5 8.1-55.8 8.1-43 0-51.5-6.7-52.7-8v-39.4c0-18 16.8-36.1 54.3-36.1 19 0 33.4 4 42.8 11.7 9.5 8 11.5 18.1 11.5 25.2l-.1 38.5z" fill="#29abe2" data-color="1"></path>
									</g>
								</svg>
								<span>{{item.author}}</span>
							</dd>
							<dd>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="20.5 27.5 159 145" viewBox="15.82352941176471 20.5 168.35294117647058 159" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="img" style="stroke-width: 1px;">
									<g>
										<path d="M179.5 89.133c0 32.438-18.159 57.416-50.694 57.416H77.139C38.659 144.387 20.5 172.5 20.5 172.5V89.349C20.5 46.747 44.712 27.5 76.166 27.5h52.748c32.427.108 50.586 25.086 50.586 61.633z"></path>
									</g>
								</svg>
								<span>{{item.comment}}</span>
							</dd>
							<dd>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="39.999 39.5 120 121" viewBox="39.99869155883789 39.5 119.99957275390625 121" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
									<g>
										<path d="M100.023 39.5c-.392 0-.782.004-1.174.013-16.024.308-30.969 6.891-42.084 18.536-11.11 11.643-17.062 26.954-16.755 43.114.62 32.717 27.519 59.337 59.965 59.337.39 0 .782-.005 1.171-.011 16.024-.308 30.969-6.893 42.084-18.536 11.112-11.647 17.063-26.956 16.757-43.114-.62-32.718-27.52-59.339-59.964-59.339zm37.188 96.609c-9.564 10.024-22.43 15.691-36.222 15.957-.337.007-.675.011-1.012.011-27.927 0-51.077-22.912-51.612-51.077-.263-13.907 4.859-27.088 14.423-37.11 9.566-10.022 22.428-15.689 36.222-15.957.339-.007.675-.009 1.014-.009 27.924 0 51.077 22.912 51.61 51.077.265 13.905-4.857 27.084-14.423 37.108z" fill="#2F54DD" data-color="1"></path>
										<path fill="#2F54DD" d="M104.178 62.848H95.82v41.363h31.694v-8.422h-23.336V62.848z" data-color="1"></path>
									</g>
								</svg>
								<span>{{item.time}}</span>
							</dd>
						</dl>
					</li>
				</ul>
				<ul v-if="download_show" class="download_content">
					<li v-for="i in 5" :key="i">
						<dl>
							<dd>​CFA考试题库大全</dd>
							<dd>
								<button>下载</button>
							</dd>
						</dl>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
	  name: 'Community_two',
	  data () {
	    return {
			download_show:false,
			list:[{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			},{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			},{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			},{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			}]
	    }
	  },
	  methods:{
		   download:function(){
		  			  this.download_show = !this.download_show
		  }
	  }
	}
</script>

<style scoped="scoped">
	@import '../../../static/css/community.css';
	
	.person_page{
		min-width: 1024px;
		background-color: rgb(100,101,112);
	}
	
	.nav_content{
		width: 220px;
		min-height: 200px;
		margin:0 auto;
		position: absolute;
		margin-top:200px;
	}
	.nav_content .user_photo{
		width: 100px;
		height: 100px;
		position: absolute;
		margin-top:-40px;
		border-radius: 50%;
		margin-left: 60px;
		border:2px #fff solid;
	}
	.nav_content .nav_content_box{
		width: 220px;
		min-height: 200px;
		background-color: rgba(45,47,58,0.5);
		border-radius: 20px;
	}
	.nav_content .nav_content_box .user_name{
		width: 180px;
		height:20px;
		margin:0 auto;
		padding-top:70px;
		padding-bottom:10px;
		font-size: 15px;
		color:rgba(199,199,199);
		text-align: center;
		border-bottom:1px rgba(199,199,199) solid;
	}	
	.nav_content .nav_content_box ul{
		width: 100%;
		overflow: hidden;
		zoom:1;
		padding-bottom:20px;
		margin-top:10px;
	}
	.nav_content .nav_content_box ul li{
		width:100%;
		height: 40px;
		line-height: 40px;
		display: block;
		text-align: center;
	}	
	.nav_content .nav_content_box ul li p{
		font-size: 14px;
		color:rgba(199,199,199);
		cursor:pointer;
	}
	.nav_content .nav_content_box ul li span{
		padding:1px 4px;
		width: 10px;
		line-height: initial;
		background: #FF5252;
		color:#fff;
		font-size:12px;
		border-radius: 100%;
		margin-top: -35px;
		margin-left:2px;
		margin-left: 30px;
		position: absolute;
	}
	.nav_content_item_active p{
		color:rgba(255,255,255) !important;
	}
	.person_components{
		width: 750px;
		min-height:200px;
		position: relative;
		margin-top:200px;
		float: right;
		right:50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/community/Community_two.vue